import { Injectable      } from '@angular/core';
import { NotifierManager } from '../managers/notifier/notifier.manager';
import { Notifier        } from '../enums/notifier/notifier.enum';
import { NotifierMessage } from '../enums/notifier/message/notifier.enum';

@Injectable
({
  providedIn: 'root'
})
export class SlotError
{
    constructor(private _notifier : NotifierManager) {}

    invalidDateIn()
    {
        this._notifier.show(Notifier.WARNING, NotifierMessage.SLOT_INVALID_DATE_IN)
    }

    lessCurrentDate()
    {
        this._notifier.show(Notifier.WARNING, NotifierMessage.SLOT_LESS_CURRENT_DATE)
    }

    bookNotExist()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.SLOT_BOOK_NOT_EXIST)
    }

    bookLessCurrentDate()
    {
        this._notifier.show(Notifier.WARNING, NotifierMessage.SLOT_BOOK_LESS_CURRENT_DATE)
    }

    bookOnlyToday()
    {
        this._notifier.show(Notifier.WARNING, NotifierMessage.SLOT_BOOK_ONLY_TODAY)
    }

    timeJustPassed()
    {
        this._notifier.show(Notifier.WARNING, NotifierMessage.SLOT_TIME_JUST_PASSED)
    }

    prenotationExist()
    {
        this._notifier.show(Notifier.WARNING, NotifierMessage.SLOT_PRENOTATION_EXIST)
    }

    timeUnavailable()
    {
        this._notifier.show(Notifier.WARNING, NotifierMessage.SLOT_TIME_UNAVAILABLE)
    }

    invalidId()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.SLOT_INVALID_ID)
    }

    invalidTimeId()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.SLOT_TIME_CREATE_INVALID_TIME_ID)
    }

    duplicatedSlot()
    {
        this._notifier.show(Notifier.WARNING, NotifierMessage.SLOT_TIME_CREATE_DUPLICATED_SLOT)
    }

    alreadyBooked()
    {
        this._notifier.show(Notifier.WARNING, NotifierMessage.SLOT_ALREADY_BOOKED)
    }

    bookableDayNotExist()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.BOOKABLE_DAY_NOT_EXIST)
    }

    invalidType()
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.SLOT_INVALID_TYPE)
    }

    dayNotFound()
    {
        this._notifier.show(Notifier.WARNING, NotifierMessage.SLOT_DAY_NOT_FOUND)
    }

}
